import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'pla-admin-founder-cockpit',
  template: `<iframe class="cockpit-frame" [style.height.px]="height" src="assets/founder-cockpit.html" title="Founder Cockpit"></iframe>`,
  styles: [`.cockpit-frame{width:100%;border:0;border-radius:10px;background:#fff;display:block;}`]
})
export class AdminFounderCockpitComponent {
  // Auto-sized from the cockpit page's own height messages so the iframe never
  // scrolls internally — the account page owns the single scrollbar.
  public height = 1400;

  @HostListener('window:message', ['$event'])
  onMessage(e: MessageEvent): void {
    // Same-origin only (the cockpit HTML is served from our own /assets).
    if (e.origin !== window.location.origin) return;
    const d: any = e.data;
    if (d && d.type === 'cockpit-height' && typeof d.height === 'number' && d.height > 0) {
      this.height = Math.ceil(d.height) + 8;
    }
  }
}
